module.exports = __webpack_public_path__ + "img/HD_gg_yq_2_18783611b.png";